import React, { useState, useRef, useEffect } from "react";
import { Card } from "reactstrap";
import { Plus, PlusCircle, Search, SearchIcon } from "lucide-react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from "react-i18next";
import CommonTable from "../CommonTable";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { deleteTest, getTestList, statusTest } from "./service/test-service";
import { useLoader } from "../../_helper/LoaderContext";
import { useCurrency } from "../../_helper/currencyContext";
import { useLab } from "../../_helper/PharmacyProvider";

export default function HomeMainTest() {
    const { t } = useTranslation();
    const [test, setTest] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const { currentLab } = useLab();
    const { getCurrencySymbol, currency: userCurrency } = useCurrency();
    const currencySymbol = getCurrencySymbol(currentLab?.baseCurrency || "INR");

    // console.log(currentLab?.baseCurrency)
    // {getCurrencySymbol(user.baseCurrency)}
    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            const res = await getTestList(form_data)
            if (res.data.success == true) {
                setTest(res.data.data.data)
                setTotalEntries(res.data.data.totalCount || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const columns = [
        { header: "Code", accessor: "code" },
        { header: "Name", accessor: "name" },
        { header: "Department", accessor: "departmentName" },
        {
            header: "Cost",
            accessor: "cost",
            render: (value) => (
                <strong>
                    {currencySymbol} {Number(value).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                </strong>
            ),
        },
    ];

    const handleToggleStatus = (data) => {
        Swal.fire({
            title: "Are you sure?",
            text: data.isActive
                ? "You want to inactivate this test?"
                : "You want to activate this test?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${data.isActive == true ? "Inactive" : "Active"}`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await statusTest(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    };

    const actions = [
        // { label: "View", onClick: (row) => console.log("View:", row) },
        { label: "Edit", onClick: (row) => Edit(row) },
        { label: "Delete", onClick: (row) => detele(row) },
        // { label: "Download", onClick: (row) => console.log("Download:", row) },
    ];

    const Edit = (row) => {
        navigate(`${process.env.PUBLIC_URL}/edit-test/${row._id}`)
    }

    const detele = (data) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this test?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, delete it!`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await deleteTest(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getList();
        }, 500); // waits 0.5s after typing stops

        return () => clearTimeout(delayDebounce);
    }, [search, currentPage, entriesPerPage]);


    return (
        <>
            <Card>
                <div className="px-3 mt-4">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group mb-3 ">
                                <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                <input type="text" className="form-control icon_form" placeholder="Search By Name" aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }} value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                            </div>

                        </div>
                        <div className="col-md-6 text-end">
                            <Link to={`${process.env.PUBLIC_URL}/add-test`}>
                                <button className="btn btn-primary">
                                    {t("Add")}
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <CommonTable
                                columns={columns}
                                data={test}
                                onToggleStatus={handleToggleStatus}
                                onAction={actions}
                                totalPages={totalPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                entriesPerPage={entriesPerPage}   // pass value
                                setEntriesPerPage={setEntriesPerPage}  // pass setter
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}
